import { getLandingPageUrl } from 'services/EnvProvider';

export const getFullUrl = (path: string = '/') => {
  const homePageUrl = getLandingPageUrl();

  return `${homePageUrl}${path}`;
};
